import {useCallback, useSyncExternalStore} from 'react';
import {Conversation} from '@stripe-internal/conversations-client';

export function useConversationLogItems(conversation: Conversation) {
  const subscribe = useCallback(
    (listener: () => void) => {
      const subscription = conversation.log.observable().subscribe(listener);
      return () => subscription.unsubscribe();
    },
    [conversation],
  );

  const getSnapshot = useCallback(() => {
    return conversation.log.get();
  }, [conversation]);

  return useSyncExternalStore(subscribe, getSnapshot);
}
